const showDrift = () => {
  const widget = document.querySelector('#drift-widget-container');
  if (widget) {
    (widget as HTMLDivElement).style.display = 'block';
  }
};

const hideDrift = () => {
  const widget = document.querySelector('#drift-widget-container');
  if (widget) {
    // If user has not interacted with bot hide widget
    (widget as HTMLDivElement).style.display = 'none';
  }
};

const resetDrift = () => {
  const timeoutId = setInterval(() => {
    if ('drift' in window) {
      clearInterval(timeoutId);
      window.drift.on('ready', (_, payload) => {
        if (!payload.sidebarOpen) {
          // Register new page change
          window.drift.page();
          hideDrift();
        }
        window.drift.on('message', () => {
          showDrift();
        });
      });
    }
  }, 100);
};

export { resetDrift, hideDrift, showDrift };
